import AppDatabase from "../../common/appDatabase";

class LocalCategoryService {
    db = new AppDatabase();

    getAllCategories = () => {
        return new Promise((resolve, reject) => {
            this.db.categories.toArray().then(
                (categories) => {
                    resolve(categories)
                }
            ).catch(error => {
                reject(error);
            })
        });
    }
}

export default LocalCategoryService